import ActionType from '../actions/ActionType'

export default (state = {
  prediction: [],
}, action) => {
  switch (action.type) {
    case ActionType.LUIS.GET_SUCCESS:
      return {
        prediction: action.payload
      }
    default:
      return state
  }
}
